/**
 * AJ2 · Envío gratis — enseña u oculta la franja según la variante elegida.
 *
 * Seis fichas de TCR tienen variantes que cruzan el umbral: el champú
 * anticaspa va de 15,99 € (una unidad) a 42,99 € (pack de tres), y lo mismo
 * el multivitaminado, el de cabello graso, el de células madre, el
 * acondicionador y la mascarilla de cuero cabelludo. Sin esto, la franja
 * diría «Envío gratis» sobre una unidad de 15,99 €, que es mentira.
 *
 * El Liquid deja un mapa de id de variante -> si llega al umbral, y aquí solo
 * se conmuta el atributo `hidden`.
 *
 * DE DÓNDE SALE LA VARIANTE (corregido el 26/09/2026). Antes se leía el
 * PRIMER input marcado del selector y se repintaba al `change` y a los
 * 200 ms. Con una sola opción funcionaba; con varias (Tamaño · Color ·
 * Cuántos tarros) el primer input marcado es el de Tamaño, y su
 * `data-variant-id` no se actualiza hasta que el tema recibe el HTML nuevo
 * del servidor. Si esa respuesta tardaba más de 200 ms, la franja se quedaba
 * con la variante anterior: pasabas de 3 tarros a 1 y seguía diciendo
 * «Envío gratis».
 *
 * Ahora se lee el JSON de la variante seleccionada que el propio selector
 * lleva dentro (`variant-picker script[type="application/json"]`) y se
 * repinta cuando el tema lo actualiza (MutationObserver). Es exactamente el
 * mismo momento en que se repinta el precio (aj2-buybox.js), así que precio y
 * franja nunca se contradicen. Se agenda con setTimeout y no con rAF, que en
 * una pestaña de fondo se congela.
 */

const leerVariante = () => {
  const script = document.querySelector('.product-information variant-picker script[type="application/json"]');
  if (script) {
    try {
      const variante = JSON.parse(script.textContent);
      if (variante && variante.id) return String(variante.id);
    } catch (error) {
      /* JSON a medio morfar: se sigue con el respaldo. */
    }
  }
  const oculto = document.querySelector('.product-information form[action*="/cart/add"] [name="id"]');
  return oculto && oculto.value ? String(oculto.value) : null;
};

/* Llama a `pintar` cada vez que el tema toca el selector de variantes. */
const seguirVariante = (pintar) => {
  const selector = document.querySelector('.product-information variant-picker');
  const raiz = (selector && selector.closest('.shopify-section')) || document.body;

  const tocaSelector = (registro) => {
    const nodo = registro.target.nodeType === 1 ? registro.target : registro.target.parentElement;
    if (nodo && nodo.closest('variant-picker')) return true;
    return Array.from(registro.addedNodes).some(
      (n) => n.nodeType === 1 && (n.matches('variant-picker') || n.querySelector('variant-picker'))
    );
  };

  let pendiente = false;
  new MutationObserver((registros) => {
    if (pendiente || !registros.some(tocaSelector)) return;
    pendiente = true;
    window.setTimeout(() => {
      pendiente = false;
      pintar();
    }, 0);
  }).observe(raiz, { childList: true, subtree: true, characterData: true });
};

class Aj2Envio extends HTMLElement {
  connectedCallback() {
    const nodo = this.querySelector('[data-aj2-envio-mapa]');
    if (!nodo) return;

    let mapa;
    try {
      mapa = JSON.parse(nodo.textContent);
    } catch (error) {
      return;
    }

    let ultima = null;
    const pintar = () => {
      const id = leerVariante();
      if (!id || id === ultima || !(id in mapa)) return;
      ultima = id;
      this.hidden = !mapa[id];
    };

    seguirVariante(pintar);
    pintar();
  }
}

if (!customElements.get('aj2-envio')) customElements.define('aj2-envio', Aj2Envio);